import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

const TooltipWrapper = styled.div`
    margin-top: 1.25rem;
`;

const Tooltip = styled.label`
    position: relative;
    cursor: pointer;
    display: inline;
    border-bottom: 1px solid var(--iam-disclaimer-tooltip-color, darkgrey);
    text-transform: none;

    input {
        position: absolute;
        left: -9999px;
    }

    input:checked + span {
        visibility: visible;
        opacity: 1;
    }
`;

const HiddenText = styled.span`
    cursor: default;
    text-transform: none;
    visibility: hidden;
    inline-size: var(--iam-disclaimer-tooltip-width, 30rem);
    padding: var(--iam-disclaimer-tooltip-spacing, 1rem);
    position: absolute;
    z-index: 1;
    top: calc(var(--iam-disclaimer-tooltip-spacing, 1rem) * 3.5);
    left: calc(var(--iam-disclaimer-tooltip-width, 30rem) / 10 * -1);
    opacity: 0;

    ::before {
        content: '';
        inline-size: 0;
        block-size: 0;
        border-left: var(--iam-disclaimer-tooltip-triangle-size, 1rem) solid transparent;
        border-right: var(--iam-disclaimer-tooltip-triangle-size, 1rem) solid transparent;
        border-bottom-width: var(--iam-disclaimer-tooltip-triangle-size, 1rem);
        position: absolute;
        top: calc(var(--iam-disclaimer-tooltip-triangle-size, 1rem) * -1);
        left: 25%;
    }

    @media (max-width: 1023px) {
        left: 0;
        inline-size: 90vw;
    }
`;

const CloseIcon = styled.div`
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
`;

interface IPrivacyNoticeProps {
    hiddenText: string;
    inputLabel: string;
}

export const PrivacyNotice = observer((props: IPrivacyNoticeProps) => {
    const { hiddenText, inputLabel } = props;

    return (
        <TooltipWrapper>
            <Tooltip className="elc-iam-privacy-label">
                {inputLabel}
                <input type="checkbox" />
                <HiddenText className="elc-iam-privacy-hidden-text">
                    <CloseIcon className="elc-iam-privacy-close-icon">X</CloseIcon>
                    <span dangerouslySetInnerHTML={{ __html: hiddenText }} />
                </HiddenText>
            </Tooltip>
        </TooltipWrapper>
    );
});
